import { ConflictStatus } from "app/models/timeslot"

export enum Types {
  PATCH = "PATCH",
  PATCH_FAIL = "PATCH_FAIL",
}

export type Action = PatchConflictsAction | PatchConflictsFailAction

export type PatchConflictsAction = {
  payload: {
    timeslotId: number
    conflictId: number
    status: ConflictStatus
  }
  type: Types.PATCH
}

export type PatchConflictsFailAction = {
  type: Types.PATCH_FAIL
  payload: { errors: object }
}

export function patchConflicts(payload: {
  timeslotId: number
  conflictId: number
  status: ConflictStatus
}): PatchConflictsAction {
  return {
    payload,
    type: Types.PATCH,
  }
}

export function patchConflictsFail(errors: object): PatchConflictsFailAction {
  return {
    payload: { errors },
    type: Types.PATCH_FAIL,
  }
}
